
/* injects from baggage-loader */

'use strict';
import StageBaseController from '../stage-base.controller';

import { chain } from 'lodash';

import { Puzzle } from '_appRoot/index.const';

export default class StageSeventhController extends StageBaseController{
    constructor($log, $state, $Forms, Dialog, Session, Trophies) {
        'ngInject';
        super($log, $state, $Forms, Dialog, Session, Trophies);
        this.title = 'Complete o Quebra Cabeça';
        this.name = 'Final Stage';
        this.forms = Puzzle.map(mapPuzzle).reverse();
        
        this.dropzones = 
            chain(this.forms)
            .clone(this.forms)
            .value()

        this.isDropValidBindded = angular.bind(this, this.isDropValid);
    }

    $onInit(){  
        if(this.Trophies.getNumberThrophies() < 6){
            this.$state.go('main');
        }

        super.$onInit();
    }

    isDropValid(data, zone){     
        console.log(data, zone);
        return data.key === zone.key;
    }

}

function mapPuzzle(p, index){
    return { image: p, key: `p${index + 1}` };
}




// WEBPACK FOOTER //
// ./src/app/pages/stage-seventh/stage-seventh.controller.js